import { DownOutlined, LoadingOutlined } from "@ant-design/icons";
import { Button, ConfigProvider, Dropdown, MenuProps, Space, Spin } from "antd";
import React from "react";

const theme = {
  components: {
    Button: {
      colorPrimary: "#00658D",
      colorPrimaryHover: "#1B394B",
      colorPrimaryActive: "#00658D",
    },
  },
};

type ActionDropdownProps = {
  buttonLabel?: string;
  icon?: React.ReactNode;
  items: MenuProps["items"];
  onMenuClick: MenuProps["onClick"];
  isDisabled?: boolean;
  isLoading?: boolean;
  children?: React.ReactNode;
};

export const ActionDropdown = (props: ActionDropdownProps) => {
  const {
    buttonLabel = "Actions",
    icon = <DownOutlined />,
    items,
    onMenuClick,
    isLoading,
    isDisabled,
    children,
  } = props;

  return (
    <ConfigProvider theme={theme}>
      <Dropdown menu={{ items, onClick: onMenuClick }} trigger={["click"]} disabled={isLoading || isDisabled}>
        <Button type="primary" style={{ borderRadius: 8 }}>
          <Space>
            {buttonLabel} {isLoading ? <Spin indicator={<LoadingOutlined spin />} /> : icon}
          </Space>
        </Button>
      </Dropdown>

      {children}
    </ConfigProvider>
  );
};
